<template>
  <div>
    <navigation />
    <div class="exam-container">
      <div class="new-exam" v-if="role === 'admin'">
        <input v-model="newExam.examName" placeholder="测试题名称" />
        <input v-model="newExam.desc" placeholder="测试题描述" />
        <!--        <select v-model="newExam.customerId">-->
        <!--          <option v-for="c of customerList" :key="`customer${c.userId}`" :value="c.userId">{{ c.userName }}</option>-->
        <!--        </select>-->
        <select v-model="newExam.type">
          <option :value="1">练习题</option>
          <option :value="2">考试题</option>
          <option :value="3">应聘练习题</option>
          <option :value="4">应聘考试题</option>
        </select>
        <button @click="createNewExam()">新建测试题</button>
      </div>
      <div class="exam-record" v-if="role !== 'admin' && role !== 'customer'">
        <el-button type="success" size="mini" @click="getUserExamRecords">查看考试记录</el-button>
      </div>
      <table width="100%" class="table">
        <thead>
          <tr>
            <th>序号</th>
            <th>测试题名</th>
            <th v-if="role === 'admin'">描述</th>
            <th v-if="role === 'admin'">状态</th>
            <th>类别</th>
            <th v-if="role === 'default'">最高分</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="exam of examList" :key="'exam' + exam.id">
            <td>{{ exam.id }}</td>
            <td>{{ exam.name }}</td>
            <td v-if="role === 'admin'">{{ exam.desc }}</td>
            <td v-if="role === 'admin'">
              {{ exam.status === 2 ? '已发布' : '未发布' }}
            </td>
            <td>
              {{ examTypeList[exam.type - 1] }}
            </td>
            <td v-if="role === 'default'">
              {{ exam.type === 3 ? exam.grade || 0 : '-' }}
            </td>
            <td>
              <span v-if="exam.isLocked" style="color: #ccc; cursor: not-allowed;">未解锁</span>
              <a @click="toStartExam(exam.type, exam.id)" v-else-if="role !== 'customer' && role !== 'admin'">{{
                operator(exam)
              }}</a>
              <a @click="toEditExam(exam.id)" v-if="role === 'admin'">编辑</a>
              <a @click="deleteExam(exam.id)" v-if="role === 'admin'">删除</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-dialog title="考试成绩" :visible.sync="dialogTableVisible">
      <el-table :data="userExamList">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column property="name" label="考试名称"></el-table-column>
        <el-table-column property="finishAt" label="时间"></el-table-column>
        <el-table-column property="grade" label="成绩"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
// import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
// import topnav from '@/components/topnav';
import * as api from '@/api/api.js';

export default {
  name: 'examlist',
  data() {
    return {
      examList: [],
      newExam: {
        examName: '',
        taskTypeId: 1,
        desc: '',
        type: 1,
      },
      role: '',
      examTypeList: ['练习题', '考试题', '应聘练习题', '应聘考试题', '错题集'],
      examTypeMap: {
        default: '3,4',
        annotator: '1',
        approver: '2',
      },
      needPractice: 1,
      userId: null,
      userExamList: [],
      dialogTableVisible: false,
    };
  },
  components: {
    // pagination,
    navigation,
    // topnav,
  },
  computed: {
    examListFilter: function() {
      if (this.role !== 'admin') return this.examList.filter(v => v.type === 1);
      else return this.examList;
    },
    operator: function() {
      return function(exam) {
        if (exam.type === 2 || exam.type === 4) {
          return exam.status && exam.type === 4 ? '重新考试' : '开始考试';
        } else if (exam.type === 3) {
          if (exam.status === 1) return '重新练习';
          else if (exam.hasStarted) return '继续练习';
          else return '开始练习';
        } else {
          return '开始练习';
        }
      };
    },
  },
  mounted: function() {
    this.role = this.$store.state.role;
    this.userId = this.$store.state.userId;
    this.getExam();
    // 如果是标注员那么会根据上月的标注情况判断是否需要完成练习题，与之对应的任务列表也需要做此判断
    if (this.role === 'annotator') {
      this.needPractice = window.localStorage.getItem('needPractice')
        ? parseInt(window.localStorage.getItem('needPractice'))
        : 1;
    }
  },
  methods: {
    getExam() {
      if (this.role === 'admin') {
        this.getExamAdmin();
      } else {
        this.getExamAnno();
      }
    },
    deleteExam(examId) {
      if (!window.confirm(`确认删除测试题${examId}?`)) return;
      api.deleteExam(examId).then(() => {
        this.$notify({
          group: 'foo',
          text: '删除成功',
          type: 'custom-blue',
          duration: 1500,
        });
        this.getExam();
      });
    },
    createNewExam() {
      api.addExam(this.newExam).then(() => {
        this.getExamAdmin();
      });
    },
    getExamAdmin() {
      api
        .getExamAdmin()
        .then(res => {
          this.examList = res.data;
        })
        .catch(err => window.console.log(err));
    },
    getExamAnno() {
      api
        .getExamAnno(this.examTypeMap[this.role] || '1')
        .then(res => {
          this.examList = this.needPractice ? res.data : [];
        })
        .catch(err => window.console.log(err));
    },
    toStartExam(examType, examId) {
      this.$router.push({ path: `/exam/${examType}/${examId}/annotate` });
    },
    toEditExam(examId) {
      this.$router.push({ path: `/editexam/${examId}` });
    },
    getUserExamRecords() {
      api.getUserExamRecords({ uid: this.userId }).then(res => {
        this.userExamList = res.data;
        if (!this.userExamList.length) {
          this.$message.warning('暂无历史考试记录');
        } else {
          this.dialogTableVisible = true;
        }
      });
    },
  },
};
</script>

<style scoped>
a {
  color: #5d89c0;
  text-decoration: none;
  display: inline-block;
  margin: 2px 5px;
  cursor: pointer;
}
p {
  display: inline-block;
  margin: 0px 6px;
  vertical-align: top;
}
section {
  display: inline-block;
  width: max-content;
  vertical-align: top;
  padding: 0px 10px;
  color: #595959;
}
section span {
  display: block;
  padding-bottom: 5px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
button {
  height: 32px;
  border: none;
  margin: 0px 12px;
}
select {
  display: inline-block;
  margin-right: 8px;
  width: 110px;
}
.new-exam {
  margin-bottom: 20px;
}
.new-exam input {
  display: inline-block;
  margin-right: 8px;
}
.new-exam select {
  display: inline-block;
  height: 21px;
  vertical-align: middle;
}
.exam-record {
  text-align: right;
  padding: 0 2px 10px 0;
}
</style>
